import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { MarkerIcon } from '../../../components/Icons';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export type LocationSectionProps = {
    course: PublicCourse;
};

export const LocationSection: FunctionComponent<LocationSectionProps> = ({ course }) => {
    if (course.type === 'on-request' || !course.address || course.delivery === 'online') {
        return null;
    }
    return (
        <section
            className={styles.location_section}
            tabIndex={0}
            aria-labelledby="location-heading"
        >
            <h2 id="location-heading">Location</h2>
            <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(Object.values(course.address).join(' '))}`}
                aria-labelledby="location-heading"
            >
                <MarkerIcon height={16} width={12} />
                <span>{Object.values(course.address).join(', ')}</span>
            </a>

            <iframe
                width="100%"
                height="250"
                style={{ border: '0', borderRadius: 5 }}
                src={`https://www.google.com/maps/embed/v1/place?key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(Object.values(course.address).join(' '))}`}
                allowFullScreen
                title="Google maps embedded view"
            />
        </section>
    );
};

export default LocationSection;
